import endpoint from 'middleware/sagas/endpoint'
import api from '../index'
import { CACHE_TAG_ACCOUNTS_VERSION_LIST, CACHE_TAG_PAYMENT_TERMS_CONFIG } from 'api/cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    updatePaymentTerms: builder.mutation({
      query: ({ accountId, paymentTermsId, inheritPaymentTermsOnUpdate, paymentDueDateType, paymentDayOfMonth }) => ({
        url: `${endpoint.account.view}/${accountId}/payment-terms`,
        method: 'PATCH',
        body: { paymentTermsId, inheritPaymentTermsOnUpdate, paymentDueDateType, paymentDayOfMonth },
      }),
      invalidatesTags: (result, error, { accountId }) => [
        { type: CACHE_TAG_ACCOUNTS_VERSION_LIST, id: accountId },
        { type: CACHE_TAG_PAYMENT_TERMS_CONFIG, id: accountId },
      ],
    }),
    getPaymentTermsConfigByAccount: builder.query({
      query: ({ accountId }) => ({
        url: `${endpoint.account.view}/${accountId}/payment-terms`,
        method: 'GET',
      }),
      providesTags: (result, error, { accountId }) => [{ type: CACHE_TAG_PAYMENT_TERMS_CONFIG, id: accountId }],
    }),
    getPaymentTermsHistoryByAccount: builder.query({
      query: ({ accountId }) => ({
        url: `${endpoint.account.view}/${accountId}/payment-terms/history`,
        method: 'GET',
      }),
    }),
  }),
})

export const { useUpdatePaymentTermsMutation, useLazyGetPaymentTermsConfigByAccountQuery, useLazyGetPaymentTermsHistoryByAccountQuery } =
  extendedApi
